// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../../node_modules/css-loader/dist/cjs.js!../members/MemberItem.css";
import ___CSS_LOADER_AT_RULE_IMPORT_1___ from "-!../../../node_modules/css-loader/dist/cjs.js!../members/MembersList.css";
import ___CSS_LOADER_AT_RULE_IMPORT_2___ from "-!../../../node_modules/css-loader/dist/cjs.js!../groups/GroupCard.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_1___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_2___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Selection Modals - Tavern Theme */

/* Import member item styles */

.modal-overlay {
  display: none;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(26, 20, 16, 0.85);
  backdrop-filter: blur(4px);
  align-items: center;
  justify-content: center;
  padding: var(--space-4);
  z-index: 1000;
}

.modal-overlay.show {
  display: flex;
}

.modal-container {
  background: var(--color-parchment-100);
  border: 4px solid var(--color-wood-700);
  border-radius: var(--radius-xl);
  width: 100%;
  max-width: 480px;
  max-height: 85vh;
  display: flex;
  flex-direction: column;
  position: relative;
  box-shadow: 0 20px 60px rgba(26, 20, 16, 0.5);
  animation: scale-in 300ms cubic-bezier(0.34, 1.56, 0.64, 1);
}

@keyframes scale-in {
  from {
    opacity: 0;
    transform: scale(0.9);
  }
  to {
    opacity: 1;
    transform: scale(1);
  }
}

.modal-close {
  position: absolute;
  top: var(--space-4);
  right: var(--space-4);
  width: 32px;
  height: 32px;
  background: var(--color-wood-800);
  border: 2px solid var(--color-wood-700);
  border-radius: 50%;
  color: var(--color-parchment-200);
  font-size: 18px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all var(--transition-fast);
  z-index: 10;
}

.modal-close:hover {
  background: var(--color-danger-500);
  color: white;
}

.modal-header {
  background: linear-gradient(180deg, var(--color-wood-800), var(--color-wood-700));
  border-bottom: 3px solid var(--color-wood-600);
  border-radius: var(--radius-xl) var(--radius-xl) 0 0;
  padding: var(--space-5);
  flex-shrink: 0;
}

.modal-title {
  font-family: var(--font-heading);
  font-size: 20px;
  font-weight: 700;
  color: var(--color-parchment-100);
  display: flex;
  align-items: center;
  gap: var(--space-3);
}

.modal-subtitle {
  font-size: 13px;
  color: var(--color-parchment-300);
  margin-top: var(--space-2);
}

/* Tabs */
.modal-tabs {
  display: flex;
  gap: 0;
  background: var(--color-wood-600);
  padding: 0;
  flex-shrink: 0;
  border-bottom: 3px solid var(--color-wood-700);
}

.modal-tab {
  flex: 1;
  padding: var(--space-3) var(--space-4);
  background: var(--color-wood-500);
  border: none;
  color: var(--color-parchment-300);
  font-family: var(--font-heading);
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: all var(--transition-fast);
  border-bottom: 3px solid transparent;
  position: relative;
}

.modal-tab:first-child {
  border-right: 2px solid var(--color-wood-700);
}

.modal-tab:hover {
  background: var(--color-wood-600);
  color: var(--color-parchment-100);
}

.modal-tab--active {
  background: var(--color-parchment-200);
  color: var(--color-wood-900);
  border-bottom-color: var(--color-fire-500);
}

.modal-search {
  background: var(--color-parchment-200);
  border: 2px solid var(--color-wood-600);
  border-radius: var(--radius-lg);
  padding: var(--space-4);
  margin: var(--space-4);
  display: flex;
  align-items: center;
  gap: var(--space-3);
  flex-shrink: 0;
}

.modal-search-icon {
  font-size: 18px;
  color: var(--color-text-secondary);
  flex-shrink: 0;
}

.modal-search-input {
  flex: 1;
  background: transparent;
  border: none;
  outline: none;
  font-size: 14px;
  font-family: var(--font-body);
  color: var(--color-text-primary);
}

.modal-search-input::placeholder {
  color: var(--color-text-secondary);
}

.modal-content {
  flex: 1;
  overflow-y: auto;
  padding: 0 var(--space-4) var(--space-4);
}

/* Selectable Member Items in Modal — MemberItem style */
.member-item--selectable {
  cursor: pointer;
  transition: all 0.2s ease;
  background: var(--color-parchment-100);
  border-color: var(--color-wood-600);
}

.member-item--selectable:hover {
  background: linear-gradient(135deg, #e8dcc8 0%, #d4c4a8 100%);
  border-color: var(--color-wood-800);
  box-shadow: 0 2px 8px rgba(109, 76, 41, 0.35);
}

.member-item--selectable .mi-avatar-wrap {
  width: 32px;
  height: 32px;
}

.member-select-icon {
  width: 24px;
  height: 24px;
  background: linear-gradient(135deg, #268d49, #1e6934);
  border: 1.5px solid var(--color-parchment-100);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-size: 13px;
  font-weight: 700;
  flex-shrink: 0;
  opacity: 0;
  transform: scale(0.7);
  transition: all 0.2s ease;
  box-shadow: 0 1px 3px rgba(30, 105, 52, 0.4);
}

.member-item--selectable:hover .member-select-icon {
  opacity: 1;
  transform: scale(1);
}

/* Selectable Group Card in Modal */
.group-card-selectable {
  cursor: pointer;
  margin-bottom: var(--space-4);
  transition: all var(--transition-normal);
  position: relative;
}

.group-card-selectable::after {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  border: 3px solid transparent;
  border-radius: var(--radius-lg);
  transition: border-color var(--transition-fast);
  pointer-events: none;
}

.group-card-selectable:hover::after {
  border-color: var(--color-fire-600);
}

.group-card-selectable:hover {
  transform: translateY(-3px);
  box-shadow: 0 8px 24px rgba(26, 20, 16, 0.3);
}

.group-card-selectable .group-card {
  margin-bottom: 0;
}

/* Make interactive elements work normally and change cursor */
.group-card-selectable .members-header,
.group-card-selectable .members-toggle-btn,
.group-card-selectable a,
.group-card-selectable button {
  cursor: pointer;
  pointer-events: auto;
  position: relative;
  z-index: 1;
}

.modal-empty-state {
  text-align: center;
  padding: var(--space-6);
  color: var(--color-text-secondary);
}

.modal-empty-icon {
  font-size: 48px;
  margin-bottom: var(--space-3);
}

.modal-empty-text {
  font-size: 14px;
}
`, "",{"version":3,"sources":["webpack://./src/features/selection/SelectionModals.css"],"names":[],"mappings":"AAAA,oCAAoC;;AAEpC,8BAA8B;;AAK9B;EACE,aAAa;EACb,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,kCAAkC;EAClC,0BAA0B;EAC1B,mBAAmB;EACnB,uBAAuB;EACvB,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,sCAAsC;EACtC,uCAAuC;EACvC,+BAA+B;EAC/B,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,6CAA6C;EAC7C,2DAA2D;AAC7D;;AAEA;EACE;IACE,UAAU;IACV,qBAAqB;EACvB;EACA;IACE,UAAU;IACV,mBAAmB;EACrB;AACF;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,iCAAiC;EACjC,uCAAuC;EACvC,kBAAkB;EAClB,iCAAiC;EACjC,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,sCAAsC;EACtC,WAAW;AACb;;AAEA;EACE,mCAAmC;EACnC,YAAY;AACd;;AAEA;EACE,iFAAiF;EACjF,8CAA8C;EAC9C,oDAAoD;EACpD,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,iCAAiC;EACjC,aAAa;EACb,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,iCAAiC;EACjC,0BAA0B;AAC5B;;AAEA,SAAS;AACT;EACE,aAAa;EACb,MAAM;EACN,iCAAiC;EACjC,UAAU;EACV,cAAc;EACd,8CAA8C;AAChD;;AAEA;EACE,OAAO;EACP,sCAAsC;EACtC,iCAAiC;EACjC,YAAY;EACZ,iCAAiC;EACjC,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,sCAAsC;EACtC,oCAAoC;EACpC,kBAAkB;AACpB;;AAEA;EACE,6CAA6C;AAC/C;;AAEA;EACE,iCAAiC;EACjC,iCAAiC;AACnC;;AAEA;EACE,sCAAsC;EACtC,4BAA4B;EAC5B,0CAA0C;AAC5C;;AAEA;EACE,sCAAsC;EACtC,uCAAuC;EACvC,+BAA+B;EAC/B,uBAAuB;EACvB,sBAAsB;EACtB,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,kCAAkC;EAClC,cAAc;AAChB;;AAEA;EACE,OAAO;EACP,uBAAuB;EACvB,YAAY;EACZ,aAAa;EACb,eAAe;EACf,6BAA6B;EAC7B,gCAAgC;AAClC;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,OAAO;EACP,gBAAgB;EAChB,wCAAwC;AAC1C;;AAEA,wDAAwD;AACxD;EACE,eAAe;EACf,yBAAyB;EACzB,sCAAsC;EACtC,mCAAmC;AACrC;;AAEA;EACE,6DAA6D;EAC7D,mCAAmC;EACnC,6CAA6C;AAC/C;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,qDAAqD;EACrD,8CAA8C;EAC9C,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,UAAU;EACV,qBAAqB;EACrB,yBAAyB;EACzB,4CAA4C;AAC9C;;AAEA;EACE,UAAU;EACV,mBAAmB;AACrB;;AAEA,mCAAmC;AACnC;EACE,eAAe;EACf,6BAA6B;EAC7B,wCAAwC;EACxC,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,6BAA6B;EAC7B,+BAA+B;EAC/B,+CAA+C;EAC/C,oBAAoB;AACtB;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,2BAA2B;EAC3B,4CAA4C;AAC9C;;AAEA;EACE,gBAAgB;AAClB;;AAEA,8DAA8D;AAC9D;;;;EAIE,eAAe;EACf,oBAAoB;EACpB,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,uBAAuB;EACvB,kCAAkC;AACpC;;AAEA;EACE,eAAe;EACf,6BAA6B;AAC/B;;AAEA;EACE,eAAe;AACjB","sourcesContent":["/* Selection Modals - Tavern Theme */\n\n/* Import member item styles */\n@import '../members/MemberItem.css';\n@import '../members/MembersList.css';\n@import '../groups/GroupCard.css';\n\n.modal-overlay {\n  display: none;\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(26, 20, 16, 0.85);\n  backdrop-filter: blur(4px);\n  align-items: center;\n  justify-content: center;\n  padding: var(--space-4);\n  z-index: 1000;\n}\n\n.modal-overlay.show {\n  display: flex;\n}\n\n.modal-container {\n  background: var(--color-parchment-100);\n  border: 4px solid var(--color-wood-700);\n  border-radius: var(--radius-xl);\n  width: 100%;\n  max-width: 480px;\n  max-height: 85vh;\n  display: flex;\n  flex-direction: column;\n  position: relative;\n  box-shadow: 0 20px 60px rgba(26, 20, 16, 0.5);\n  animation: scale-in 300ms cubic-bezier(0.34, 1.56, 0.64, 1);\n}\n\n@keyframes scale-in {\n  from {\n    opacity: 0;\n    transform: scale(0.9);\n  }\n  to {\n    opacity: 1;\n    transform: scale(1);\n  }\n}\n\n.modal-close {\n  position: absolute;\n  top: var(--space-4);\n  right: var(--space-4);\n  width: 32px;\n  height: 32px;\n  background: var(--color-wood-800);\n  border: 2px solid var(--color-wood-700);\n  border-radius: 50%;\n  color: var(--color-parchment-200);\n  font-size: 18px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  transition: all var(--transition-fast);\n  z-index: 10;\n}\n\n.modal-close:hover {\n  background: var(--color-danger-500);\n  color: white;\n}\n\n.modal-header {\n  background: linear-gradient(180deg, var(--color-wood-800), var(--color-wood-700));\n  border-bottom: 3px solid var(--color-wood-600);\n  border-radius: var(--radius-xl) var(--radius-xl) 0 0;\n  padding: var(--space-5);\n  flex-shrink: 0;\n}\n\n.modal-title {\n  font-family: var(--font-heading);\n  font-size: 20px;\n  font-weight: 700;\n  color: var(--color-parchment-100);\n  display: flex;\n  align-items: center;\n  gap: var(--space-3);\n}\n\n.modal-subtitle {\n  font-size: 13px;\n  color: var(--color-parchment-300);\n  margin-top: var(--space-2);\n}\n\n/* Tabs */\n.modal-tabs {\n  display: flex;\n  gap: 0;\n  background: var(--color-wood-600);\n  padding: 0;\n  flex-shrink: 0;\n  border-bottom: 3px solid var(--color-wood-700);\n}\n\n.modal-tab {\n  flex: 1;\n  padding: var(--space-3) var(--space-4);\n  background: var(--color-wood-500);\n  border: none;\n  color: var(--color-parchment-300);\n  font-family: var(--font-heading);\n  font-size: 14px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all var(--transition-fast);\n  border-bottom: 3px solid transparent;\n  position: relative;\n}\n\n.modal-tab:first-child {\n  border-right: 2px solid var(--color-wood-700);\n}\n\n.modal-tab:hover {\n  background: var(--color-wood-600);\n  color: var(--color-parchment-100);\n}\n\n.modal-tab--active {\n  background: var(--color-parchment-200);\n  color: var(--color-wood-900);\n  border-bottom-color: var(--color-fire-500);\n}\n\n.modal-search {\n  background: var(--color-parchment-200);\n  border: 2px solid var(--color-wood-600);\n  border-radius: var(--radius-lg);\n  padding: var(--space-4);\n  margin: var(--space-4);\n  display: flex;\n  align-items: center;\n  gap: var(--space-3);\n  flex-shrink: 0;\n}\n\n.modal-search-icon {\n  font-size: 18px;\n  color: var(--color-text-secondary);\n  flex-shrink: 0;\n}\n\n.modal-search-input {\n  flex: 1;\n  background: transparent;\n  border: none;\n  outline: none;\n  font-size: 14px;\n  font-family: var(--font-body);\n  color: var(--color-text-primary);\n}\n\n.modal-search-input::placeholder {\n  color: var(--color-text-secondary);\n}\n\n.modal-content {\n  flex: 1;\n  overflow-y: auto;\n  padding: 0 var(--space-4) var(--space-4);\n}\n\n/* Selectable Member Items in Modal — MemberItem style */\n.member-item--selectable {\n  cursor: pointer;\n  transition: all 0.2s ease;\n  background: var(--color-parchment-100);\n  border-color: var(--color-wood-600);\n}\n\n.member-item--selectable:hover {\n  background: linear-gradient(135deg, #e8dcc8 0%, #d4c4a8 100%);\n  border-color: var(--color-wood-800);\n  box-shadow: 0 2px 8px rgba(109, 76, 41, 0.35);\n}\n\n.member-item--selectable .mi-avatar-wrap {\n  width: 32px;\n  height: 32px;\n}\n\n.member-select-icon {\n  width: 24px;\n  height: 24px;\n  background: linear-gradient(135deg, #268d49, #1e6934);\n  border: 1.5px solid var(--color-parchment-100);\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: white;\n  font-size: 13px;\n  font-weight: 700;\n  flex-shrink: 0;\n  opacity: 0;\n  transform: scale(0.7);\n  transition: all 0.2s ease;\n  box-shadow: 0 1px 3px rgba(30, 105, 52, 0.4);\n}\n\n.member-item--selectable:hover .member-select-icon {\n  opacity: 1;\n  transform: scale(1);\n}\n\n/* Selectable Group Card in Modal */\n.group-card-selectable {\n  cursor: pointer;\n  margin-bottom: var(--space-4);\n  transition: all var(--transition-normal);\n  position: relative;\n}\n\n.group-card-selectable::after {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  border: 3px solid transparent;\n  border-radius: var(--radius-lg);\n  transition: border-color var(--transition-fast);\n  pointer-events: none;\n}\n\n.group-card-selectable:hover::after {\n  border-color: var(--color-fire-600);\n}\n\n.group-card-selectable:hover {\n  transform: translateY(-3px);\n  box-shadow: 0 8px 24px rgba(26, 20, 16, 0.3);\n}\n\n.group-card-selectable .group-card {\n  margin-bottom: 0;\n}\n\n/* Make interactive elements work normally and change cursor */\n.group-card-selectable .members-header,\n.group-card-selectable .members-toggle-btn,\n.group-card-selectable a,\n.group-card-selectable button {\n  cursor: pointer;\n  pointer-events: auto;\n  position: relative;\n  z-index: 1;\n}\n\n.modal-empty-state {\n  text-align: center;\n  padding: var(--space-6);\n  color: var(--color-text-secondary);\n}\n\n.modal-empty-icon {\n  font-size: 48px;\n  margin-bottom: var(--space-3);\n}\n\n.modal-empty-text {\n  font-size: 14px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
